export default __webpack_public_path__ + "static/media/imgGuide.98330aa2.png";